<template>
  <div v-if="sousProduit.prestations">
    <div class="columns is-multiline" v-if="!detail">
      <selecteur-action
        @handleAction="handleAction"
        :options="actions"
        :placeholder='$t("general.placeHolder.groupedAction")'
        :elementsSelectionnes="getAllSelected.length > 0"
        titleButton="general.button.apply"
        class="column is-narrow mgb-0">
      </selecteur-action>
      <div class="column has-text-right">
        <a class="button is-addOrEdit" @click="addLigne()">
          {{ $t('produitSalon.prestations.actions.add')}}
        </a>
      </div>
    </div>
    <div v-else class="columns is-justify-content-end">
      <div class="column is-narrow is-align-self-center">
        <div class="lien has-text-right">
          <span
            class="is-cursor-pointer"
            @click="displayPrestationInactif = !displayPrestationInactif">
            {{ displayPrestationInactif
              ? $t('produitSalon.prestations.actions.displayPrestationInactif',
                { number: getInactifNumber })
              : $t('produitSalon.prestations.actions.masquerPrestationInactif',
                { number: getInactifNumber })
            }}
          </span>
        </div>
      </div>
      <div class="column is-narrow">
        <exportExcelButton
          :perm="permissions.exporter"
          :query="exportExcelQuery"/>
      </div>
    </div>
    <v-client-table
      :data="prestations"
      :columns="columns"
      :options="options"
      class="overflow-x-auto min-height-50vw"
      ref="tableListePrestation">
      <template slot='afterTable'>
        <table-items-in-view @input="$refs.tableListePrestation.setLimit($event)"/>
      </template>
      <template slot="selected" slot-scope="props">
        <b-checkbox
          v-model="props.row.selected"
          @input="updateLignes(props, 'selected')">
        </b-checkbox>
      </template>
      <template slot="code" slot-scope="props">
        <b-input v-if="!detail"
          v-model="props.row.reference"
          @input="updateLignes(props, 'reference')">
        </b-input>
        <span v-else>{{ props.row.reference }}</span>
      </template>
      <template slot="libelle" slot-scope="props">
        <b-input v-if="!detail"
          v-model="props.row.libelle"
          @input="updateLignes(props, 'libelle')">
        </b-input>
        <span v-else>{{ props.row.libelle }}</span>
      </template>
      <template slot="typeEvenementSponsoring" slot-scope="props">
        <parametre-autocomplete
          v-if="!detail"
          v-model="props.row.typeEvenementSponsoringId"
          :target="constantes.PARAMETRES_KEYS.typeEvenementSponsoring"
          expanded
          @input="updateLignes(props, 'typeEvenementSponsoringId')"
        />
        <span v-else>
          {{ getTypeEvenementSponsoringById(props.row.typeEvenementSponsoringId) }}
        </span>
      </template>
      <template slot="categorieOperation" slot-scope="props">
        <b-select
          v-if="!detail"
          v-model="props.row.categorieOperation"
          @input="updateLignes(props, 'categorieOperation')"
          expanded>
          <option :value="null"></option>
          <option
            v-for="categorie in categorieOperations"
            :key="categorie.code"
            :value="categorie.code">
            {{ $t(categorie.libelle) }}
          </option>
        </b-select>
        <span v-else>{{ $t(getCategorieOperation(props.row.categorieOperation)) }}</span>
      </template>
      <template slot="le" slot-scope="props">
        <b-datepicker
          v-if="!detail"
          v-model="props.row.dateSignature"
          @input="updateLignes(props, 'dateSignature')"
          icon="calendar-today"
          nearby-selectable-month-days
          editable show-week-number>
        </b-datepicker>
        <span v-else>{{ props.row.dateSignature | formatDate }}</span>
      </template>
      <template slot="dateFin" slot-scope="props">
        <b-datepicker
          v-if="!detail"
          v-model="props.row.dateFin"
          @input="updateLignes(props, 'dateFin')"
          icon="calendar-today"
          nearby-selectable-month-days
          editable show-week-number>
        </b-datepicker>
        <span v-else>{{ props.row.dateFin | formatDate }}</span>
      </template>
      <template slot="dateTarif" slot-scope="props">
        <b-datepicker
          v-if="!detail"
          v-model="props.row.dateTarif"
          @input="updateLignes(props, 'dateTarif')"
          icon="calendar-today"
          nearby-selectable-month-days
          editable show-week-number>
        </b-datepicker>
        <span v-else>{{ props.row.dateTarif | formatDate }}</span>
      </template>
      <template slot="prixUnitaire" slot-scope="props">
        <b-input
          v-if="!detail"
          v-model.number="props.row.prixUnitaire"
          @input="updateLignes(props, 'prixUnitaire')">
        </b-input>
        <span v-else>{{ props.row.prixUnitaire | formatDevise }}</span>
      </template>
      <template slot="tauxTva" slot-scope="props">
        <b-select
          v-if="!detail"
          v-model="props.row.tauxTva"
          @input="updateLignes(props, 'tauxTva')"
          expanded>
          <option
            v-for="tva in getRegimeTva(props.row)"
            :key="tva.tauxTva"
            :value="tva.tauxTva">
            {{ formatPercent(tva.tauxTva) }}
          </option>
        </b-select>
        <span v-else>{{ formatPercent(props.row.tauxTva) }}</span>
      </template>
      <template slot="actif" slot-scope="props">
        {{ $t(`general.${props.row.actif ? 'oui' : 'non'}`) }}
      </template>
      <template slot="delete" slot-scope="props">
        <a @click="deleteLigne(props.index)">
          <b-icon icon="delete-forever" type="is-danger" class="mgt-5px"/>
        </a>
      </template>
    </v-client-table>
    <b-modal
      v-model="popUpCategorieOperation"
      class="modal"
      has-modal-card>
      <pop-up-categorie-operation @apply="applyTypeCategorieOperation"/>
    </b-modal>
  </div>
</template>

<script>
import selecteurAction from '@/components/general/selecteurAction';
import TableItemsInView from '@/components/general/TableItemsInView';
import genererPrestation from '@/services/presse/prestations/genererPrestations';
import cloneDeep from 'lodash/cloneDeep';
import PopUpCategorieOperation from '@/components/catalogue/produitGeneralPresse/edition/p_categorieOperation';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import {
  ACTION_ARCHIVER,
  ACTION_DESARCHIVER,
  ACTION_DUPLICATION,
  ACTION_SUPPRESSION,
  ACTION_CATEGORIE_OPERATION,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { EXPORT_EXCEL_PRESTATION } from '@/configuration/presse/produitPresse/produitPresseConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import formatPercent from '@/services/general/filters/formatPercent';
import { columnsSplice } from '@/services/general/columns';
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'CatalogueProduitGeneralPresseEditPrestations',
  components: {
    selecteurAction,
    TableItemsInView,
    PopUpCategorieOperation,
    exportExcelButton,
    ParametreAutocomplete,
  },
  props: {
    produit: {
      type: Object,
      required: true,
    },
    sousProduit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
    },
    permissions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      actions: [
        { action: ACTION_DUPLICATION, translation: 'produitPresse.encarts.actions.dupliquer' },
        { action: ACTION_ARCHIVER, translation: 'produitPresse.encarts.actions.archiver' },
        { action: ACTION_DESARCHIVER, translation: 'produitPresse.encarts.actions.desarchiver' },
        { action: ACTION_SUPPRESSION, translation: 'produitPresse.encarts.actions.supprimer' },
        { action: ACTION_CATEGORIE_OPERATION, translation: 'produitPresse.encarts.actions.categorieOperation' },
      ],
      displayPrestationInactif: false,
      popUpCategorieOperation: false,
      categorieOperations: produitConf.CATEGORIE_OPERATION,
      formatPercent,
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    typeEvenementSponsoring() {
      return this.parametre(PARAMETRES_KEYS.typeEvenementSponsoring);
    },
    getAllSelected() {
      return this.sousProduit.prestations.filter(c => c.selected);
    },
    allIsSelected() {
      return this.getAllSelected.length === this.sousProduit.prestations.length;
    },
    getInactifNumber() {
      return this.sousProduit.prestations
        .filter((encart) => { return encart.actif === false; }).length;
    },
    prestations() {
      if (this.displayPrestationInactif) {
        return this.sousProduit.prestations
          .filter(el => el.actif === this.displayPrestationInactif);
      }
      return this.sousProduit.prestations;
    },
    columns() {
      const columns = [
        'selected', 'code', 'libelle', 'typeEvenementSponsoring', 'categorieOperation', 'le', 'dateFin',
        'dateTarif', 'prixUnitaire', 'tauxTva', 'actif', 'delete',
      ];
      if (this.detail) {
        columnsSplice(columns, 'selected');
        columnsSplice(columns, 'delete');
      }
      return columns;
    },
    iconSelectTotal() {
      if (this.allIsSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          delete: '',
          code: this.$t('produitSalon.prestations.tab.code'),
          libelle: this.$t('produitSalon.prestations.tab.libelle'),
          actif: this.$t('produitSalon.prestations.tab.actif'),
          typeEvenementSponsoring: this.$t('produitSalon.prestations.tab.typeEvenementSponsoring'),
          categorieOperation: this.$t('produitSalon.prestations.tab.categorieOperation'),
          le: this.$t('produitSalon.prestations.tab.le'),
          dateFin: this.$t('produitSalon.prestations.tab.dateFin'),
          dateTarif: this.$t('produitSalon.prestations.tab.dateTarif'),
          prixUnitaire: this.$t('produitSalon.prestations.tab.prixUnitaire'),
          tauxTva: this.$t('produitSalon.prestations.tab.tauxTva'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    const allSelected = this.allIsSelected;
                    this.sousProduit.prestations.forEach(c => {
                      c.selected = !allSelected;
                    });
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
          selected: 'colonneSelected',
          libelle: 'colonneWidth270px',
          le: 'colonneMinWidth-150px',
          dateFin: 'colonneMinWidth-150px',
          dateTarif: 'colonneMinWidth-150px',
          tauxTva: 'colonneMinWidth-100px',
        },
        sortable: this.detail ? ['code', 'libelle', 'typeEvenementSponsoring', 'du', 'au', 'le', 'dateFin', 'dateTarif', 'prixUnitaire', 'tauxTva', 'actif'] : [],
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_PRESTATION,
        typeExport: null,
        filtres: {
          query: {
            produitId: this.produit.id,
            categorieVente: this.produit.supportCommercial.categorieVente,
            displayPrestationInactif: this.displayPrestationInactif,
          },
        },
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getTypeEvenementSponsoringById(typeId) {
      const typeEvenementSponsoring = this.parametre(PARAMETRES_KEYS.typeEvenementSponsoring)
        .find((type) => {
          return type.id === typeId;
        });
      return typeEvenementSponsoring ? typeEvenementSponsoring.libelle : '';
    },
    updateLignes(props, key) {
      const ligneFind = this.sousProduit.prestations[props.index - 1];
      if (ligneFind) this.$set(ligneFind, key, props.row[key]);
    },
    deleteLigne(propsIndex) {
      this.sousProduit.prestations.splice(propsIndex - 1, 1);
    },
    addLigne() {
      this.sousProduit.prestations.unshift(genererPrestation());
    },
    duplicationPrestations() {
      const newPrestation = cloneDeep(this.sousProduit
        .prestations.filter((el) => el.selected));
      newPrestation.forEach((el) => {
        el.selected = false;
        if (el.id) delete el.id;
      });
      this.sousProduit.prestations = this.sousProduit.prestations.concat(newPrestation);
    },
    archiverPrestations(state) {
      this.sousProduit.prestations
        .filter((el) => el.selected)
        .forEach((el) => { el.actif = state; });
    },
    getRegimeTva(encart) {
      return this.parametre(PARAMETRES_KEYS.regimeTva).filter((tva) => {
        return tva.actif || encart.tauxTva === tva.tauxTva;
      });
    },
    handleAction(type) {
      switch (type) {
        case ACTION_SUPPRESSION:
          this.sousProduit.prestations = this.sousProduit.prestations
            .filter((el) => !el.selected);
          break;
        case ACTION_DUPLICATION:
          this.duplicationPrestations();
          break;
        case ACTION_ARCHIVER:
          this.archiverPrestations(false);
          break;
        case ACTION_DESARCHIVER:
          this.archiverPrestations(true);
          break;
        case ACTION_CATEGORIE_OPERATION:
          this.popUpCategorieOperation = true;
          break;
        default:
          break;
      }
    },
    applyTypeCategorieOperation(categorieOperation) {
      this.sousProduit.prestations.filter((el) => el.selected).forEach((el) => {
        el.categorieOperation = categorieOperation;
      });
    },
    getCategorieOperation(value) {
      const find = this.categorieOperations.find((el) => el.code === value);
      return find?.libelle;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    if (!this.detail) this.displayPrestationInactif = false;
    try {
      await this.loadParametres([
        PARAMETRES_KEYS.typeEvenementSponsoring,
        PARAMETRES_KEYS.regimeTva,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
